<template>
  <div class="container p-article l-article-main">
    <!-- 內文頁主體 -->
    <div class="p-article__body">
      <div class="e-category">
        <div class="e-category__main">
          {{ main_category }}
        </div>
        <div class="e-category__child">
          {{ datas.video.main_category }}
        </div>
      </div>
      <span v-if="datas.video.type !== 'general'" :class="articleType(datas.video).style" class="e-type">
        {{ articleType(datas.video).text }}
      </span>
      <h1 class="p-article__title">
        {{ datas.video.title }}
      </h1>
      <p class="p-article-info">
        <span v-if="author" class="p-article-info__author">
          <nuxt-link v-if="authorUrl()" :to="`/author/${authorUrl().split('/author/')[1]}/`" title="前往此編輯報導總覽頁面">{{ author }}</nuxt-link>
          <template v-else>{{ author }}</template>
        </span>
        <span class="p-article-info__time-wrapper">
          {{ publishTime[0] }}
          <time :datetime="datas.video.publish_at_time_zone" class="p-article-info__time" itemprop="datePublished">
            {{ publishTime[1] }}
          </time>
        </span>
      </p>
      <!-- Top Tag -->
      <div v-show="isOver18 === true" id="article-tag-top" class="l-tags__wrapper">
        <nuxt-link
          v-for="(tag, index) in datas.video.tags"
          :key="index"
          :to="`/search/${tag.trim()}/`"
          :title="`使用${tag}關鍵字前往搜尋頁並搜尋`"
          :rel="tag.length > 6 ? 'nofollow' : ''"
          class="e-tag l-tags__item"
        >
          {{ tag }}
        </nuxt-link>
      </div>
      <!-- Top Tag -->
      <!-- 18禁確認畫面 -->
      <div v-if="is18content === true && isOver18 === false" class="p-article__18">
        <div class="p-article__18-body">
          <div class="m-modal__18x-img">
            <img src="https://static.ctwant.com/images/dist/18+.svg" alt="確認年齡滿18圖示">
          </div>
          <p class="m-modal__18x-text">
            <img src="https://static.ctwant.com/images/dist/lock.svg" alt="確認年齡滿18鎖定圖示">
            本文含有成人內容  請確定您已年滿18歲
          </p>
        </div>
        <div class="p-article__18-footer">
          <button class="e-btn m-modal__btn m-modal__btn--refuse" title="確認未滿18歲" @click="notOver18">
            <img src="https://static.ctwant.com/images/dist/xx.svg" alt="close-icon">
            我未滿18 歲
          </button>
          <button class="e-btn m-modal__btn m-modal__btn--confirm" title="確認已滿18歲" @click="over18">
            <img src="https://static.ctwant.com/images/dist/oo.svg" alt="check-icon">
            我已滿18 歲
          </button>
        </div>
      </div>
      <!-- 18禁確認畫面 -->
      <!-- 主要內容區 -->
      <div v-show="isOver18 === true" ref="content" class="p-article__content">
        <div class="p-article__img-box">
          <div class="e-video">
            <iframe
              :src="`https://www.youtube.com/embed/${datas.video.youtube_id}?autoplay=1&loop=1&mute=1`"
              frameborder="0"
              allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
          <p class="p-article__cover-graph">
            {{ datas.video.cover_graph }}
          </p>
        </div>
        <div class="m-fontsize">
          <button class="e-btn m-fontsize__item" title="放大內文字級" aria-label="放大內文字級" @click="fontPlus">
            A+
          </button>
          <button class="e-btn m-fontsize__item" title="縮小內文字級" aria-label="縮小內文字級" @click="fontMinus">
            A-
          </button>
        </div>
        <article>
          <div :style="{ fontSize: `${articleFontSize}px` }" v-html="datas.video.content" />
          <!-- Bottom Tag -->
          <div id="article-tag-bottom" class="l-tags__wrapper bottom">
            <nuxt-link
              v-for="(tag, index) in datas.video.tags"
              :key="index"
              :to="`/search/${tag.trim()}/`"
              :title="`使用${tag}關鍵字前往搜尋頁並搜尋`"
              :rel="tag.length > 6 ? 'nofollow' : ''"
              class="e-tag l-tags__item"
            >
              {{ tag }}
            </nuxt-link>
          </div>
          <!-- Bottom Tag -->
        </article>
        <ShareBar
          ref="shareBar"
          :base="'video'"
          :data-id="datas.video.video_id"
          :data-title="datas.video.title"
          :data-next="datas.next"
          :sharebar-fixed="sharebarFixed"
          :is-show-share="isShowShare"
          @update="shareBarUpdateIsShowShare"
        />
      </div>
      <!-- 主要內容區 -->
      <div class="l-ad__wrapper mb-2 mt-1" style="min-height: 90px;">
        <div id="div-gpt-ad-1590467132070-0" ref="div-gpt-ad-1590467132070-0" />
      </div>
      <!-- 系列文章 -->
      <SeriesArticles
        v-show="isOver18 === true"
        :article-type="'video'"
        :series-data="datas.video.series"
      />
      <!-- 系列文章 -->
      <!-- 延伸閱讀 -->
      <ExtendedArticle v-show="isOver18 === true" :init-data="datas.video.extended" />
      <!-- 延伸閱讀 -->
      <div :class="{'mb-4': !isMobile, 'mt-4': !isMobile}" class="l-ad__wrapper">
        <div class="l-ad__banner">
          <div id="div-gpt-ad-1562662964306-0" ref="div-gpt-ad-1562662964306-0" style="height: 100px;" />
          <!-- <div id="div-gpt-ad-1563877894783-0" ref="div-gpt-ad-1563877894783-0" style="width: 1px; height: 1px;" /> -->
        </div>
      </div>
      <!-- 手機側邊欄 -->
      <SideBarForMobile :data="datas" :type="'video'" />
      <!-- 手機側邊欄 -->
      <!-- 熱門推薦-->
      <div id="_popIn_recommend" ref="_popIn_recommend" style="min-height: 500px;" />
      <!--
      <div class="l-section">
        <h2 class="l-section__title-with-hr">
          熱門推薦
        </h2>
        <hr>
        <div class="l-section__content">
          <div class="row">
            <nuxt-link v-for="i in datas.news" :key="i.video_id" :to="`/video/${i.video_id}/`" class="m-card col-sm-4 col-6">
              <div v-if="i.type !== 'general'" class="e-type--bg m-card__type">
                <span :class="articleType(i).style" class="e-type">
                  {{ articleType(i).text }}
                </span>
              </div>
              <div class="e-video__img-container">
                <LazyImage :src="i.cover.md" :alt="i.title" class="m-card__img" />
                <div class="e-video__icon-wrapper">
                  <div class="e-video__icon" />
                </div>
              </div>
              <h3 class="m-card__title m-card--mle-2">
                {{ i.title }}
              </h3>
            </nuxt-link>
          </div>
        </div>
      </div>
      -->
    </div>
    <!-- 內文頁主體 -->
    <!-- 側邊欄 -->
    <SideBar :data="datas" :type="'video'" />
    <!-- 側邊欄 -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import articleHelpers from '@/utils/articleHelpers.js'
import adTabIndexRemove from '@/utils/adTabIndexRemove.js'
import ShareBar from '@/components/ShareBar.vue'
import SeriesArticles from '@/components/SeriesArticles.vue'
import SideBar from '@/components/SideBar.vue'
import SideBarForMobile from '@/components/SideBarForMobile.vue'
import ExtendedArticle from '@/components/ExtendedArticle.vue'
import scrollToTop from '@/utils/scrollToTop.js'

export default {
  components: {
    ShareBar,
    SeriesArticles,
    ExtendedArticle,
    SideBar,
    SideBarForMobile
  },
  mixins: [articleHelpers, adTabIndexRemove],
  validate({ params, redirect }) {
    if (/^\d+$/.test(params.id) === false) {
      redirect(301, '/')
    }
    return /^\d+$/.test(params.id)
  },
  async asyncData({ $axios, route, params, query, redirect, error }) {
    const api = $axios.defaults.baseURL
    const url = `${api}/video/${params.id}`

    try {
      if (!params.id.match(/^\d+$/)) {
        throw new TypeError('error format video id', params.id)
      }
      if (route.path.substr(-1) !== '/' && Object.keys(query).length <= 0) {
        redirect(301, `${route.path}/`)
      }
      const data = await $axios.$get(url)
      return {
        datas: data.data,
        main_category: '影音',
        is18content: data.data.video.is_adult === 'Y'
      }
    } catch (e) {
      console.error('Video', {
        code: e.response.data.code,
        message: e.response.data.message,
        method: e.response.config.method,
        url: e.response.config.url
      })
      error({ statusCode: 404 })
    }
  },
  data() {
    return {
      datas: null,
      main_category: '',
      lastScrollTop: 0,
      sharebarFixed: false,
      isSetSharebarFixed: false,
      isShowShare: false,
      articleFontSize: 18,
      publishTime: [],
      timeOut: null,
      is18content: false,
      isOver18: true
    }
  },
  head() {
    const articleData = {
      title: `${this.datas.video.title} | ${this.main_category} | CTWANT`,
      url: this.HOST + (this.$route.path.substr(this.$route.path.length - 1) === '/' ? this.$route.path : `${this.$route.path}/`),
      thumbnailUrl: this.datas.video.cover.md,
      main_category: this.main_category,
      keywords: `${this.datas.video.title}, ${this.datas.video.tags.join(', ')}`,
      articleSection: this.main_category,
      description: this.datas.video.pure_content.replace(/<[^>]+>|&[^>]+;/g, '').trim().substr(0, 100),
      articleBody: this.datas.video.pure_content,
      author: this.datas.video.participants.reporter || this.datas.video.participants.editor || this.datas.video.participants.author || 'CTWANT',
      creator: this.datas.video.participants.reporter || this.datas.video.participants.editor || this.datas.video.participants.author || 'CTWANT',
      createTime: this.datas.video.publish_at_time_zone,
      updateTime: this.datas.video.updated_at_time_zone
    }
    const NewsArticle = {
      '@context': 'http://schema.org',
      '@type': 'NewsArticle',
      headline: articleData.title,
      url: articleData.url,
      thumbnailUrl: articleData.thumbnailUrl,
      articleSection: articleData.articleSection,
      description: articleData.description,
      articleBody: articleData.articleBody,
      creator: {
        '@type': 'Person',
        name: articleData.author
      },
      author: {
        '@type': 'Person',
        name: articleData.creator
      },
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': articleData.url
      },
      image: {
        '@type': 'ImageObject',
        url: articleData.thumbnailUrl
      },
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        logo: {
          '@type': 'ImageObject',
          url: 'https://static.ctwant.com/images/dist/logo.png'
        }
      },
      dateCreated: articleData.createTime,
      datePublished: articleData.createTime,
      dateModified: articleData.updateTime
    }
    const VideoObject = {
      '@context': 'http://schema.org',
      '@type': 'VideoObject',
      name: articleData.title,
      description: articleData.description,
      thumbnailUrl: articleData.thumbnailUrl,
      uploadDate: articleData.createTime,
      // duration: 'PT2M15S',
      embedUrl: `https://www.youtube.com/embed/${this.datas.video.youtube_id}`,
      contentUrl: `https://www.youtube.com/watch?v=${this.datas.video.youtube_id}`,
      publisher: {
        '@type': 'Organization',
        name: 'CTWANT',
        logo: {
          '@type': 'ImageObject',
          url: 'https://yt3.googleusercontent.com/ytc/AIdro_luvZ4bxIX8xZPgOVlRyszyK-nNAc_J3-aYn43YIBZG9A=s160-c-k-c0x00ffffff-no-rj'
        }
      }
    }
    const BreadcrumbList = {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': this.HOST,
            name: 'CTWANT'
          }
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': `${this.HOST}/video`,
            name: articleData.main_category
          }
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@id': articleData.url,
            name: articleData.title
          }
        }
      ]
    }
    const SeriesListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.datas.video.series.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover.md,
          url: `https://www.ctwant.com/video/${item.id}`
        }
      })
    }
    const HotNewsListItem = {
      '@context': 'http://schema.org',
      '@type': 'ItemList',
      itemListElement: this.datas.popular.map((item, index) => {
        return {
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          image: item.cover.md,
          url: `https://www.ctwant.com/video/${item.video_id}`
        }
      }).slice(0, 5)
    }

    return {
      title: `${articleData.title}`,
      meta: [
        { hid: 'description', name: 'description', content: articleData.description },
        { hid: 'keywords', name: 'keywords', content: articleData.keywords },
        { hid: 'author', name: 'author', content: 'CTWANT' },
        { hid: 'ogUrl', property: 'og:url', content: articleData.url },
        { hid: 'ogType', property: 'og:type', content: 'website' },
        { hid: 'ogTitle', property: 'og:title', content: articleData.title },
        { hid: 'ogDescription', property: 'og:description', content: articleData.description },
        {
          hid: 'max-image-preview',
          name: 'robots',
          content: 'max-image-preview:standard'
        },
        { hid: 'ogImage', property: 'og:image', content: articleData.thumbnailUrl },
        { hid: 'videoPublished_time', name: 'pubdate', property: 'video:published_time', itemprop: 'datePublished', content: articleData.createTime },
        { hid: 'videoModified_time', name: 'lastmod', property: 'video:modified_time', itemprop: 'dateModified', content: articleData.updateTime },
        { hid: 'articleSection', property: 'article:section', itemprop: 'articleSection', content: articleData.main_category }
      ],
      link: [
        { hid: 'alternate', rel: 'alternate', hreflang: 'zh-Hant', href: articleData.url },
        { hid: 'canonical', rel: 'canonical', href: articleData.url }
      ],
      __dangerouslyDisableSanitizers: ['script'],
      script: [
        { innerHTML: JSON.stringify(NewsArticle), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(BreadcrumbList), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(VideoObject), type: 'application/ld+json' },
        { innerHTML: JSON.stringify(SeriesListItem.itemListElement.length > 0 ? SeriesListItem : HotNewsListItem), type: 'application/ld+json' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'HOST',
      'WIDTH_PAD',
      'screenWidth',
      'scrollTop',
      'isMobile'
    ]),
    selectImageSize() {
      const sw = this.screenWidth
      return function (imageArr) {
        let imgUrl = null

        if (sw <= this.WIDTH_PAD) {
          imgUrl = imageArr.sm
        } else {
          imgUrl = imageArr.md
        }
        return imgUrl
      }
    },
    author() {
      const participants = this.datas.video.participants
      const participantsLength = Object.keys(participants).length
      // 依據作者數目建立佔位
      const sortArray = [...Array(participantsLength)]

      if (participantsLength > 0) {
        for (const a in participants) {
          if (participants[a] !== '') {
            switch (a) {
              case 'reporter':
                sortArray.splice(0, 1, `記者：${participants[a]}`)
                break
              case 'editor':
                sortArray.splice(1, 1, `編輯：${participants[a]}`)
                break
              case 'author':
                sortArray.splice(2, 1, `作者：${participants[a]}`)
                break
            }
          } else {
            switch (a) {
              case 'reporter':
                sortArray.splice(0, 1)
                break
              case 'editor':
                sortArray.splice(1, 1)
                break
              case 'author':
                sortArray.splice(2, 1)
                break
            }
          }
        }
        return sortArray.length !== 0 ? `${sortArray.join('　')}` : ''
      } else {
        return ''
      }
    }
  },
  watch: {
    scrollTop() {
      if (!this.isSetSharebarFixed) {
        return false
      }
      let contentOffsetTop = null

      if (this.$refs.content !== undefined) {
        contentOffsetTop = this.$refs.content.getBoundingClientRect().top + this.scrollTop
      }

      if (this.scrollTop > contentOffsetTop) {
        this.sharebarFixed = true
      } else {
        this.sharebarFixed = false
      }
    }
  },
  mounted() {
    this.publishTime = this.datas.video.publish_at.split(' ')
    if (this.is18content === false) {
      this.init()
    } else {
      this.showOver18Modal()
    }
  },
  beforeDestroy() {
    if (this.is18content === true) {
      clearTimeout(this.timeOut)
    }
  },
  methods: {
    init() {
      const userFontSize = JSON.parse(window.localStorage.getItem('fontSize'))

      if (this.$refs.content !== undefined && this.screenWidth > this.WIDTH_PAD) {
        this.isShowShare = true
        this.isSetSharebarFixed = true
      }

      if (this.screenWidth <= this.WIDTH_PAD) {
        this.isShowShare = false
      }

      if (userFontSize !== null) {
        this.articleFontSize = userFontSize
      }

      this.$nextTick(() => {
        this.$store.dispatch('ad/displayAd', {
          isHideAd: this.datas.video.is_hide_ad,
          isOtherAd: this.datas.video.is_other_ad
        })
        this.$store.dispatch('ad/registerAndDisplayPopupAd', { type: this.main_category })
        this.$gtm.push({
          event: 'domMounted',
          pageUrl: this.$route.fullPath,
          pageTitle: this.datas.video.title,
          pageCategory: this.main_category
        })
        // 讓後端統計即時流量用
        this.$axios.$post(`${this.$config.baseURL}/realtime-pv`, { url: window.location.href })

        if (this.isMobile === false) {
          this.$_adTabIndexRemoveFn([
            this.$refs['div-gpt-ad-1590467132070-0'],
            document.getElementById('div-gpt-ad-1562665659288-0'),
            document.getElementById('div-gpt-ad-1566899414172-0'),
            document.getElementById('div-gpt-ad-1579516679912-0'),
            this.$refs['div-gpt-ad-1562662964306-0']
            // this.$refs['div-gpt-ad-1563877894783-0']
          ])
          this.$_adTabIndexRemoveFromTagA([
            this.$refs._popIn_recommend
          ])
        }
      })
    },
    authorUrl() {
      const participants = this.datas.video.participants
      let paSetSize = 0
      let ps = []
      let role = ''
      for (const a in participants) {
        if (participants[a] !== '') {
          role = a
          paSetSize++
          const p = participants[a]
          ps = p.split('、')
          if (ps.length > 1) { return '' }
        }
      }
      if (paSetSize === 1) {
        return `${this.HOST}/author/${role}/${ps[0]}`
      }
    },
    showOver18Modal() {
      const sessionOver18 = sessionStorage.getItem('over18')
      if (sessionOver18 !== 'true') {
        this.isOver18 = false
      } else {
        this.isOver18 = true
        this.$store.dispatch('ad/disableAd')
        this.timeOut = setTimeout(() => {
          this.init()
        }, 200)
      }
    },
    notOver18() {
      this.$router.push({
        path: '/'
      })
    },
    over18() {
      this.isOver18 = true
      sessionStorage.setItem('over18', true)
      if (process.client) {
        scrollToTop(0, 1500, 'easeInOutQuint')
      }
      this.$store.dispatch('ad/disableAd')
      this.timeOut = setTimeout(() => {
        this.init()
      }, 200)
    },
    fontPlus() {
      this.articleFontSize += 1
      localStorage.setItem('fontSize', this.articleFontSize)
    },
    fontMinus() {
      this.articleFontSize -= 1
      localStorage.setItem('fontSize', this.articleFontSize)
    },
    shareBarUpdateIsShowShare(bool) {
      this.isShowShare = bool
    },
    shareFn() {
      this.$refs.shareBar.mobileShare()
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/modules/_modal';
@import '~/assets/scss/layout/_article-main';
@import '~/assets/scss/pages/_article';
</style>
